module.exports = __webpack_public_path__ + "img/ic-arrow-up.ed100dbb.svg";